import { DynamicFormControlLayout, serializable } from '@ng-dynamic-forms/core';
import { CustomDynamicSelectModel, CustomDynamicSelectModelConfig } from '../shared-models/custom-dynamic-select.model';

export const TYPE_CHIP_CHOICE_MULTIPLE = 'CHIP-CHOICE-MULTIPLE';

export interface ChipChoiceMultipleModelConfig<T> extends CustomDynamicSelectModelConfig<T> {
}

export class ChipChoiceMultipleModel<T> extends CustomDynamicSelectModel<T> {
  @serializable() readonly type: string = TYPE_CHIP_CHOICE_MULTIPLE;

  constructor(config: ChipChoiceMultipleModelConfig<T>, layout?: DynamicFormControlLayout) {
    super(config, layout);

    // make multiple by default
    if (typeof config.multiple !== 'boolean') {
      this.multiple = true;
    }

    // tell ng-dynamic-forms not to display additional label and errorMessages
    this.additional = {
      ...this.additional,
      isFormFieldControl: true
    };
  }
}
